var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReupload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4635 7.6259C16.7534 7.92174 17.2282 7.92655 17.5241 7.63664C17.8199 7.34673 17.8247 6.87188 17.5348 6.57604C16.1291 5.14149 14.1676 4.25 11.9992 4.25C7.71901 4.25 4.24921 7.71979 4.24921 12L2.79916 12C2.46955 12 2.28139 12.3763 2.47916 12.64L4.67916 15.5733C4.83916 15.7867 5.15916 15.7867 5.31916 15.5733L7.51916 12.64C7.71693 12.3763 7.52878 12 7.19916 12L5.74921 12C5.74921 8.54822 8.54743 5.75 11.9992 5.75C13.7482 5.75 15.3282 6.4674 16.4635 7.6259Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6792 8.42667L16.4792 11.36C16.2814 11.6237 16.4695 12 16.7992 12L18.2492 12C18.2492 15.4518 15.4509 18.25 11.9992 18.25C10.2502 18.25 8.67011 17.5326 7.53484 16.3741C7.24494 16.0782 6.77009 16.0734 6.47424 16.3633C6.17839 16.6532 6.17357 17.1281 6.46348 17.4239C7.86925 18.8585 9.83077 19.75 11.9992 19.75C16.2794 19.75 19.7492 16.2802 19.7492 12L21.1992 12C21.5288 12 21.7169 11.6237 21.5192 11.36L19.3192 8.42667C19.1592 8.21333 18.8392 8.21333 18.6792 8.42667Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReupload);
export default __webpack_public_path__ + "static/media/Reupload.58d119393ba11374208dd2f5d4fdb39e.svg";
export { ForwardRef as ReactComponent };